<template>
    <div class="landing-player-container">
        <insight-landing-player
            v-if="audioSources.length"
            ref="insigthPlayer"
            :sources="selectedAudio"
            html5
            @end="onPlaybackEnd"
            @load="onLoad"
            @play="onPlay"
            @pause="onPause"
        />
    </div>
</template>

<script>
import playerContainerMixing from "@/mixins/audioContainerMixins.js"
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import { mapState } from "vuex";

export default {
    name: "LandingPlayerContainer",
    components: {
        insightLandingPlayer: () => import(/* webpackChunkName: "insights-player"*/ "@c/landing-player/player")
    },
    mixins: [playerContainerMixing],
    props: {
        bookInsight: {
            type: Object,
            required: true
        },
        playingBookInsight: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            currentSlideIndex: state => state.LandingCarousel.currentSlideIndex
        })
    },
    watch: {
        playingBookInsight(value, oldValue) {
            if (oldValue && value != oldValue) {
                this.$refs["insigthPlayer"].pause();
            }
        },
        currentSlideIndex() {
            this.pause()
        }
    },
    mounted() {
        if (!_isEmpty(this.bookInsight)) {
            this.initializeContainer(this.bookInsight)
        }
    },
    methods: {
        initializeContainer(bookInsight) {
            this.clearContainer();
            this.formatSources(bookInsight.themes);
        },
        onPlay() {
            const album = _get(this.bookInsight, "external_book.title", this.bookInsight.title);
            const title = this.bookInsight.title;
            const artist = this.bookInsight.authors.map((author) => author.name).join(", ");
            const artworkSrc = _get(this.bookInsight, "external_book.cover_url", "");
            let artwork = [] ;
            if (artworkSrc.length) {
                artwork = [{ src: artworkSrc }];
            }
            if ("mediaSession" in navigator) {
                navigator.mediaSession.playbackState = "playing";
                navigator.mediaSession.metadata = new MediaMetadata({
                    album,
                    artist,
                    artwork,
                    title
                });

                navigator.mediaSession.setActionHandler("play", this.play);
                navigator.mediaSession.setActionHandler("pause", this.pause);
            }
            if (this.$route.name.includes("bi-campaigns-landing")) {
                this.$_trackAll("play_example", { themeTitle: album, insightSlug: title });
            }
            this.$emit("on-play", this.bookInsight.id);
        },
        onPause() {
            if (this.$route.name.includes("bi-campaigns-landing")) {
                const themeTitle = _get(this.bookInsight, "external_book.title", this.bookInsight.title);
                const insightSlug = this.bookInsight.title;
                this.$_trackAll("pause_example", { insightSlug, themeTitle });
            }
        }
    }
}
</script>
